/* Towelio Fresh V5 — combined production scripts */

/* Source: fresh-conversion-v4.js */
(() => {
  const initFreshPage = (root) => {
    if (!root || root.dataset.freshInitialized === 'true') return;
    root.dataset.freshInitialized = 'true';

    root.querySelectorAll('[data-fresh-quantity]').forEach((control) => {
      const input = control.querySelector('input');
      const minus = control.querySelector('[data-fresh-minus]');
      const plus = control.querySelector('[data-fresh-plus]');
      if (!input) return;

      const change = (amount) => {
        const min = Number(input.min || 1);
        const max = Number(input.max || 10);
        input.value = String(Math.min(max, Math.max(min, Number(input.value || 1) + amount)));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      };

      minus?.addEventListener('click', () => change(-1));
      plus?.addEventListener('click', () => change(1));
    });

    const revealItems = root.querySelectorAll('[data-fresh-reveal]');
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.13, rootMargin: '0px 0px -6% 0px' });
      revealItems.forEach((item) => observer.observe(item));
    } else {
      revealItems.forEach((item) => item.classList.add('is-visible'));
    }
  };

  const boot = () => document.querySelectorAll('[data-fresh-conversion-v4]').forEach(initFreshPage);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();



/* Source: fresh-packages-v2.js */
(() => {
  const setClarityTags = (tags) => {
    if (typeof window.clarity !== 'function') return;

    Object.entries(tags).forEach(([key, value]) => {
      if (value === undefined || value === null || value === '') return;
      window.clarity('set', key, String(value).slice(0, 255));
    });
  };

  const trackClarityEvent = (name, tags = {}) => {
    if (typeof window.clarity !== 'function') return;
    setClarityTags(tags);
    window.clarity('event', name);
  };

  const getCheckoutCtaLocation = (button) => {
    if (!(button instanceof HTMLElement)) return 'unknown';
    if (button.classList.contains('fresh-conversion-v4__mobile-cod')) return 'mobile_sticky';
    if (button.classList.contains('fresh-conversion-v4__cod-floating')) return 'desktop_floating';
    if (button.closest('.fresh-conversion-v4__cod-inline--benefits')) return 'benefits';
    if (button.closest('.fresh-conversion-v4__cod-inline--packages')) return 'packages';
    if (button.classList.contains('fresh-conversion-v4__add')) return 'primary_buy';
    return 'other';
  };

  const initFreshPackages = (root) => {
    if (!root || root.dataset.freshPackagesInitialized === 'true') return;
    root.dataset.freshPackagesInitialized = 'true';

    const options = Array.from(root.querySelectorAll('[data-fresh-package]'));
    const priceOutputs = root.querySelectorAll('[data-fresh-package-price]');
    const shippingOutputs = root.querySelectorAll('[data-fresh-package-shipping]');
    const titleOutputs = root.querySelectorAll('[data-fresh-package-title]');
    const variantInput = root.querySelector('input[name="id"]');
    const productForm = root.querySelector('form.fresh-conversion-v4__form');
    const checkoutButtons = Array.from(root.querySelectorAll('button[type="submit"]'))
      .filter((button) => button.form === productForm);

    const resetCheckoutButtons = () => {
      checkoutButtons.forEach((button) => {
        if (button.getAttribute('aria-busy') !== 'true') return;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      });
    };

    const selectPackage = (option) => {
      options.forEach((item) => {
        const selected = item === option;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-pressed', String(selected));
      });

      priceOutputs.forEach((output) => { output.textContent = option.dataset.price || ''; });
      shippingOutputs.forEach((output) => { output.textContent = option.dataset.shipping || ''; });
      const selectedTitle = option.querySelector('.fresh-conversion-v4__package-title')?.textContent?.trim() || '';
      titleOutputs.forEach((output) => { output.textContent = selectedTitle; });

      if (variantInput && option.dataset.variantId) {
        variantInput.value = option.dataset.variantId;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      resetCheckoutButtons();
    };

    const goDirectlyToCheckout = (event) => {
      event.preventDefault();

      const variantId = variantInput?.value?.trim() || '';
      if (!/^\d+$/.test(variantId)) return;

      const selectedOption = options.find((option) => option.classList.contains('is-selected')) || options[0];
      const selectedTitle = selectedOption?.querySelector('.fresh-conversion-v4__package-title')?.textContent?.trim() || '';
      trackClarityEvent('towelio_begin_checkout_cod', {
        selected_package: selectedTitle,
        selected_price: selectedOption?.dataset.price || '',
        shipping_offer: selectedOption?.dataset.shipping || '',
        checkout_cta: getCheckoutCtaLocation(event.submitter),
        payment_method: 'cash_on_delivery',
      });

      checkoutButtons.forEach((button) => {
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
      });

      window.location.assign(`/cart/${variantId}:1?checkout&locale=tr`);
    };

    options.forEach((option) => option.addEventListener('click', () => {
      selectPackage(option);
      trackClarityEvent('towelio_package_selected', {
        selected_package: option.querySelector('.fresh-conversion-v4__package-title')?.textContent?.trim() || '',
        selected_price: option.dataset.price || '',
        shipping_offer: option.dataset.shipping || '',
      });
    }));
    productForm?.addEventListener('submit', goDirectlyToCheckout);
    window.addEventListener('pageshow', resetCheckoutButtons);
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) resetCheckoutButtons();
    });

    const initial = options.find((option) => option.classList.contains('is-selected')) || options[0];
    if (initial) {
      selectPackage(initial);
      setClarityTags({
        towelio_page: 'conversion_landing',
        selected_package: initial.querySelector('.fresh-conversion-v4__package-title')?.textContent?.trim() || '',
        selected_price: initial.dataset.price || '',
        shipping_offer: initial.dataset.shipping || '',
        payment_method: 'cash_on_delivery',
      });
    }
  };

  const boot = () => document.querySelectorAll('[data-fresh-conversion-v4]').forEach(initFreshPackages);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();



/* Source: fresh-gallery-v2.js */
(() => {
  const initFreshGallery = (root) => {
    if (!root || root.dataset.freshGalleryInitialized === 'true') return;
    root.dataset.freshGalleryInitialized = 'true';

    const mainImage = root.querySelector('[data-fresh-gallery-main]');
    const mainVideo = root.querySelector('[data-fresh-gallery-video]');
    const galleryFrame = mainImage?.closest('.fresh-conversion-v4__hero-frame');
    const thumbs = Array.from(root.querySelectorAll('[data-fresh-gallery-thumb]'));
    const previous = root.querySelector('[data-fresh-gallery-prev]');
    const next = root.querySelector('[data-fresh-gallery-next]');
    if (!mainImage || !mainVideo || !thumbs.length) return;

    let activeIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));
    let touchStartX = 0;
    let touchStartY = 0;
    let ignoreNextImageClick = false;

    const clearDirection = () => {
      root.classList.remove('is-gallery-moving-next', 'is-gallery-moving-prev');
    };

    const show = (index, direction = 1) => {
      activeIndex = (index + thumbs.length) % thumbs.length;
      const thumb = thumbs[activeIndex];
      const source = thumb.dataset.src;
      if (!source) return;

      clearDirection();
      root.classList.add(direction < 0 ? 'is-gallery-moving-prev' : 'is-gallery-moving-next');

      const isVideo = thumb.dataset.mediaType === 'video';
      root.classList.toggle('is-fresh-video', isVideo);
      root.classList.toggle('is-fresh-infographic', !isVideo && thumb.dataset.infographic === 'true');
      root.classList.toggle('is-fresh-overlay-detail', !isVideo && thumb.dataset.overlayDetail === 'true');
      root.classList.toggle('is-fresh-primary-video', isVideo && thumb.dataset.primaryVideo === 'true');

      thumbs.forEach((item, itemIndex) => {
        const active = itemIndex === activeIndex;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });

      if (thumb.offsetParent !== null) {
        thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }

      if (isVideo) {
        mainImage.classList.remove('is-changing');
        mainVideo.setAttribute('aria-label', thumb.dataset.alt || 'Ürün kullanım videosu');
        if (mainVideo.getAttribute('src') !== source) {
          mainVideo.src = source;
          mainVideo.load();
        }
        const playPromise = mainVideo.play();
        if (playPromise) playPromise.catch(() => {});
        window.setTimeout(clearDirection, 420);
        return;
      }

      mainVideo.pause();
      mainImage.classList.add('is-changing');
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      window.setTimeout(() => {
        mainImage.src = source;
        mainImage.alt = thumb.dataset.alt || '';
        mainImage.onload = () => {
          mainImage.classList.remove('is-changing');
          window.setTimeout(clearDirection, 420);
        };
        window.setTimeout(() => {
          mainImage.classList.remove('is-changing');
          clearDirection();
        }, 850);
      }, 150);
    };

    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => show(index, index < activeIndex ? -1 : 1)));
    previous?.addEventListener('click', () => show(activeIndex - 1, -1));
    next?.addEventListener('click', () => show(activeIndex + 1, 1));

    mainImage.addEventListener('click', () => {
      if (!window.matchMedia('(max-width: 749px)').matches || ignoreNextImageClick) return;
      show(activeIndex + 1, 1);
    });

    galleryFrame?.addEventListener('touchstart', (event) => {
      const touch = event.touches[0];
      touchStartX = touch?.clientX || 0;
      touchStartY = touch?.clientY || 0;
    }, { passive: true });

    galleryFrame?.addEventListener('touchend', (event) => {
      const touch = event.changedTouches[0];
      if (!touch) return;
      const distanceX = touch.clientX - touchStartX;
      const distanceY = touch.clientY - touchStartY;
      if (Math.abs(distanceX) < 42 || Math.abs(distanceX) < Math.abs(distanceY) * 1.2) return;

      ignoreNextImageClick = true;
      show(activeIndex + (distanceX < 0 ? 1 : -1), distanceX < 0 ? 1 : -1);
      window.setTimeout(() => { ignoreNextImageClick = false; }, 450);
    }, { passive: true });
  };

  const boot = () => document.querySelectorAll('[data-fresh-conversion-v4]').forEach(initFreshGallery);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();



/* Source: towelio-usage-showcase-v1.js */
(() => {
  const videos = Array.from(document.querySelectorAll('[data-towelio-usage-video]'));
  if (!videos.length) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduceMotion && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          const playPromise = video.play();
          if (playPromise) playPromise.catch(() => {});
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.45 });

    videos.forEach((video) => observer.observe(video));
  }

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) videos.forEach((video) => video.pause());
  });
})();





/* Load video bytes only when the media is close to the viewport. */
(() => {
  const hydrate = (video) => {
    if (!video || video.dataset.towelioVideoHydrated === 'true') return;
    const sources = Array.from(video.querySelectorAll('source[data-src]'));
    if (!sources.length) return;
    sources.forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });
    video.dataset.towelioVideoHydrated = 'true';
    video.load();
    if (video.autoplay || video.hasAttribute('data-towelio-usage-video')) {
      const play = () => {
        const promise = video.play();
        if (promise) promise.catch(() => {});
      };
      if (video.readyState >= 2) play();
      else video.addEventListener('canplay', play, { once: true });
    }
  };

  const observe = (scope = document) => {
    const videos = Array.from(scope.querySelectorAll('video:has(source[data-src])'));
    if (!videos.length) return;
    if (!('IntersectionObserver' in window)) {
      videos.forEach(hydrate);
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        hydrate(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '120px 0px', threshold: 0.01 });
    videos.forEach((video) => observer.observe(video));
  };

  const boot = () => observe(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', (event) => observe(event.target));
})();









